{
  "source": "handover/role-reference.json",
  "source_sha256": "c0aed4cb1f708c6e740bfb2170397eab536348ac0e208325394a8db925da0962",
  "roles": [
    {
      "id": "org-admin",
      "title": "Organisation administrator",
      "group": "Govern",
      "heading": "A consistent foundation for every site.",
      "intro": "Manage people, policy and the shared operating framework. Operational and privacy powers are separate grants.",
      "boundary": "No visitor admission, access provisioning, privacy deletion or incident command.",
      "nav": [
        "users",
        "policies",
        "sites"
      ],
      "primary": [
        "Review users",
        "users"
      ],
      "tasks": [
        [
          "users",
          "User access",
          "Review active accounts and protect the last administrator."
        ],
        [
          "policies",
          "Policy versions",
          "Draft the approval pattern; this does not enforce a live policy."
        ],
        [
          "sites",
          "Site framework",
          "Review locations and room capacity."
        ]
      ]
    },
    {
      "id": "site-admin",
      "title": "Site administrator",
      "group": "Govern",
      "heading": "Keep your site ready to welcome.",
      "intro": "Maintain local spaces and operating instructions without inheriting organisation-wide security powers.",
      "boundary": "No global users, approval decisions, access commands or privacy cases.",
      "nav": [
        "sites",
        "communications"
      ],
      "primary": [
        "Manage spaces",
        "sites"
      ],
      "tasks": [
        [
          "sites",
          "Rooms & spaces",
          "Review capacity and add a local meeting space."
        ],
        [
          "communications",
          "Local communication",
          "Review templates and routing drafts; no messages are sent."
        ]
      ]
    },
    {
      "id": "host",
      "title": "Host / employee",
      "group": "Welcome",
      "heading": "Your guests. One clear plan.",
      "intro": "Invite visitors, keep plans current and follow the arrival journey. Your view includes only visits hosted by Omar.",
      "boundary": "Cannot approve your own requests, verify identity, admit visitors or view another host’s records.",
      "nav": [
        "visits"
      ],
      "primary": [
        "Invite a visitor",
        "@new-visit"
      ],
      "tasks": [
        [
          "visits",
          "Your invitations",
          "Create, amend or cancel a visit and track its independent states."
        ]
      ]
    },
    {
      "id": "reception",
      "title": "Reception",
      "group": "Welcome",
      "heading": "Make every arrival feel effortless.",
      "intro": "See who is expected, resolve missing prerequisites and record actual arrivals and departures.",
      "boundary": "Cannot approve visits or confirm a logical access outcome. Credential exceptions go to the platform operator.",
      "nav": [
        "reception",
        "visits",
        "deliveries",
        "credentials"
      ],
      "primary": [
        "Open arrival desk",
        "reception"
      ],
      "tasks": [
        [
          "reception",
          "Arrival desk",
          "Verify evidence and record observed presence."
        ],
        [
          "credentials",
          "Physical custody",
          "Assign or recover a card without implying logical access."
        ],
        [
          "deliveries",
          "Package handover",
          "Track the package separately from the courier."
        ]
      ]
    },
    {
      "id": "approver",
      "title": "Approver",
      "group": "Assure",
      "heading": "Clear decisions. Traceable reasons.",
      "intro": "Review pending requests, record a decision and keep approval distinct from identity and admission.",
      "boundary": "Review identity is Sara Al Noor for the own-host check. Sara’s own requests cannot be approved here; reassignment is specified, not simulated.",
      "nav": [
        "approvals"
      ],
      "primary": [
        "Review requests",
        "approvals"
      ],
      "tasks": [
        [
          "approvals",
          "Approval inbox",
          "Make a reasoned decision on a request owned by another host."
        ]
      ]
    },
    {
      "id": "guard",
      "title": "Guard / gate operator",
      "group": "Operate",
      "heading": "Know the blocker before the barrier.",
      "intro": "Check a linked visit and record a gate observation. A recognised vehicle never means permission to enter.",
      "boundary": "No visitor directory, identity evidence, policy changes or remote barrier actuation.",
      "nav": [
        "vehicles"
      ],
      "primary": [
        "Review gate queue",
        "vehicles"
      ],
      "tasks": [
        [
          "vehicles",
          "Gate checks",
          "Plate, visit eligibility and observed movement stay separate."
        ]
      ]
    },
    {
      "id": "permit",
      "title": "Contractor / permit reviewer",
      "group": "Assure",
      "heading": "The right evidence before work begins.",
      "intro": "Review contractor evidence and bounded work authorisation. A permit does not replace individual visitor checks.",
      "boundary": "Cannot grant logical access or mark people as departed. Suspension creates unresolved access work where necessary.",
      "nav": [
        "contractors"
      ],
      "primary": [
        "Review work permits",
        "contractors"
      ],
      "tasks": [
        [
          "contractors",
          "Work packages",
          "Accept evidence before approving the permit; inspect suspension impact."
        ]
      ]
    },
    {
      "id": "emergency",
      "title": "Emergency coordinator",
      "group": "Operate",
      "heading": "Account for people. Expose uncertainty.",
      "intro": "Start a training muster, review the captured roster and record individual observations. This is not an emergency service.",
      "boundary": "Does not trigger alarms, guarantee physical location or rewrite visitor presence from a roll-call observation.",
      "nav": [
        "safety"
      ],
      "primary": [
        "Open training muster",
        "safety"
      ],
      "tasks": [
        [
          "safety",
          "Muster coordination",
          "Capture a roster, account for each person and close with a reason."
        ]
      ]
    },
    {
      "id": "analyst",
      "title": "Analyst / report-only",
      "group": "Understand",
      "heading": "Understand the operation, not the identity.",
      "intro": "Review scoped totals and independent state counts. This proposed reporting profile has no person-level export grant.",
      "boundary": "No visitor names, raw event log, scheduled exports or operational changes. AI remains an optional Enterprise+ add-on.",
      "nav": [
        "summary"
      ],
      "primary": [
        "View aggregate report",
        "summary"
      ],
      "tasks": [
        [
          "summary",
          "Daily operating picture",
          "Compare observed presence, pending approvals and unknown access outcomes."
        ]
      ]
    },
    {
      "id": "auditor",
      "title": "Auditor",
      "group": "Understand",
      "heading": "Follow the evidence, without changing it.",
      "intro": "Review who did what and where uncertainty remains. Demo history is editable local data, not a tamper-resistant audit service.",
      "boundary": "No operational decisions, user administration, privacy case editing or record mutation.",
      "nav": [
        "auditlog"
      ],
      "primary": [
        "Inspect audit trail",
        "auditlog"
      ],
      "tasks": [
        [
          "auditlog",
          "Event review",
          "Inspect actor, action, scope and record reference."
        ]
      ]
    },
    {
      "id": "privacy",
      "title": "Privacy reviewer",
      "group": "Assure",
      "heading": "Respect the request. Prove the outcome.",
      "intro": "Verify the requester, review the hold and track each simulated storage outcome before closing a case.",
      "boundary": "No blanket record deletion, user administration or assumed downstream completion. Retention periods remain unresolved.",
      "nav": [
        "privacy"
      ],
      "primary": [
        "Open subject requests",
        "privacy"
      ],
      "tasks": [
        [
          "privacy",
          "Subject requests",
          "Identity, scope, hold and store results are separate review steps."
        ]
      ]
    },
    {
      "id": "operator",
      "title": "Integration / platform operator",
      "group": "Operate",
      "heading": "Recover the outcome, not just the connection.",
      "intro": "Inspect dependency health and reconcile uncertain credentials using simulated read-back outcomes.",
      "boundary": "No routine visitor admission, approval, privacy deletion or user-management grant. No real provider is connected.",
      "nav": [
        "integrations",
        "operations",
        "credentials"
      ],
      "primary": [
        "Open recovery queue",
        "credentials"
      ],
      "tasks": [
        [
          "credentials",
          "Access recovery",
          "Confirm revocation before releasing a held card."
        ],
        [
          "integrations",
          "Provider readiness",
          "Inspect supported-operation and read-back requirements."
        ],
        [
          "operations",
          "Background work",
          "Simulate failure or retry; transport health is not success."
        ]
      ]
    },
    {
      "id": "visitor",
      "title": "Visitor",
      "group": "Public journeys",
      "heading": "A confident start to your visit.",
      "intro": "Review your invitation and complete pre-registration without entering the staff workspace.",
      "boundary": "Invitation-scoped synthetic preview; no public directory, real login, QR credential or identity-provider connection.",
      "nav": [
        "portal"
      ],
      "primary": [
        "Open invitation",
        "portal/PV-104"
      ],
      "tasks": []
    },
    {
      "id": "kiosk",
      "title": "Shared-device kiosk",
      "group": "Public journeys",
      "heading": "Welcome to Dubai HQ.",
      "intro": "Find a synthetic invitation or request assistance. No staff workspace is exposed.",
      "boundary": "Reference lookup only. Real token protection, scanning, walk-in policy, Arabic and hardened device management remain pending.",
      "nav": [
        "kiosk",
        "portal"
      ],
      "primary": [
        "Open kiosk",
        "kiosk"
      ],
      "tasks": []
    }
  ]
}
